export const STRING_SCREEN_APPLYING_TO = 'Applying to';
export const STRING_SCREEN_IN = 'in';

// CollectNameAndPhoneNumber screen
export const STRING_SCREEN_APPLY_NOW = 'Apply Now';
export const STRING_SCREEN_CONTINUE = 'Continue';

// UploadResumeOrCreateProfile screen
export const STRING_SCREEN_UPLOAD_RESUME_DESCRIPTION = 'Upload a resume to apply to this job.';
export const STRING_SCREEN_BUILD_PROFILE_OR_RESUME_DESCRIPTION = 'You can build a profile within 2 minutes or upload a resume file!';
export const STRING_SCREEN_BUILD_PROFILE = 'Build a Profile';
export const STRING_SCREEN_UPLOAD = 'Upload';
export const STRING_SCREEN_UPLOAD_RESUME = 'Upload a Resume';
export const STRING_SCREEN_SKIP_STEP = 'Skip this step →';
export const STRING_SCREEN_DONT_HAVE_RESUME = 'I don’t have a resume →';
export const STRING_SCREEN_PARSING_RESUME = 'Scanning Your Resume...';
export const STRING_SCREEN_FAILED_PARSE_MESSAGE = 'Your resume looks invalid. Double-check to make sure it’s right and if it’s not, try uploading a new file before applying.';

export const STRING_SCREEN_ADD_ANOTHER = 'Add another';
export const STRING_SCREEN_NO_MORE = 'I don’t have another';

export const STRING_SCREEN_EXPERIENCE = 'Work Experience';
export const STRING_SCREEN_EXPERIENCE_ADD_ANOTHER_SUCCESS = 'Saved! Add another entry if you have one.';

export const STRING_SCREEN_EDUCATION = 'Education';
export const STRING_SCREEN_EDUCATION_ADD_ANOTHER_SUCCESS = 'Saved! Add another entry if you have one.';

export const STRING_PLEASE_WAIT = 'Please wait...';

// UploadResumeOrCreateProfile check-in variants
export const STRING_CHECK_IN_START_TITLE = 'Get Invited to Apply!';
export const STRING_CHECK_IN_START_DESCRIPTION = 'Upload a resume or build a profile so that I can promote you to employers.';

export const STRING_CHECK_IN_FAILED_PARSE_MESSAGE = 'There was an issue uploading your resume. Try uploading again.';

// UploadResumeOrCreateProfile screen component names
export const CONTACT = 'contact';
export const CONTACT_PARSE_RESUME = 'contact_parse_resume';
export const CONTACT_PROFILE_OR_PARSE_RESUME = 'contact_profile_or_parse_resume';
export const CONTACT_POST_PARSE = 'contact_post_parse';
export const CONTACT_SKIPPABLE_PARSE_RESUME = 'contact_skippable_parse_resume';
export const CONTACT_SKIPPABLE_PROFILE_OR_PARSE_RESUME = 'contact_skippable_profile_or_parse_resume';
export const EDUCATION = 'education';
export const RESUME_PROFILE_START = 'resume_profile_start';
export const WORK_EXPERIENCE = 'work_experience';

export const STRING_CLOSE = 'Close';

// Warning Modal on Apply Flow
export const STRING_WANT_TO_CANCEL_PROMPT = 'Are you sure you want to cancel?';
export const STRING_KEEP_GOING = 'Keep Going';
export const STRING_CANCEL_APPLICATION = 'Cancel Application';
export const STRING_CANCEL_APPLICATION_EXPLANATION = 'If you stop now you will have to restart the application process if you apply in the future.';
export const STRING_CANCEL_PROFILE_UPDATE_EXPLANATION = 'If you stop now your profile may look incomplete to employers. It will also be harder to match you with the right jobs.';
export const STRING_CANCEL = 'Cancel';

// RDB opt-in tooltip
export const RDB_OPT_IN_TOOLTIP = 'If you make your profile public, all information you choose to add to your profile will be available to hiring managers who have access to our resume database or associated features';

// Existing Email Address Modal on Apply Flow
export const STRING_CTA_START = 'We\'re sending you an email you can use to verify and access your account. If you\'d like to create a password, ';
export const STRING_CTA_LINK_NAME = 'create one here.';
